import fetch from 'isomorphic-fetch';
import errorSvc from 'services/errorService';
import configSvc from 'services/configService';
import contextService from 'services/contextService';
import encodeUtils from 'services/encodeUtils';

const ubaUrlRoot = configSvc.get('ubaUrlRoot');

function getOrigin () {
  return window.location.protocol + '//' + window.location.host;
}

async function fetchAndTrackSession (url, params) {
  const response = await fetch(url, params);
  return response;
}

function getOAuthToken () {
  let token = contextService.get('oauthToken');
  if (!token) {
    token = getAccessToken();
  }
  return token;
}

function getAccessToken () {
  let token = localStorage.accessToken || sessionStorage.accessToken;
  if (token) {
    return token;
  }
  const encoded = localStorage.aurycTk || sessionStorage.aurycTk;
  if (encoded) {
    try {
      token = encodeUtils.decodeBase64(encoded).split(':')[0];
      return token;
    } catch (e) {
      return false;
    }
  }
  return false;
}

function authHeader () {
  return {
    'X-Authorized-Identity': contextService.get('siteId'),
    'X-Authorized-Token': contextService.get('siteToken'),
    'Authorization': `Bearer ${getOAuthToken()}`
  };
}

function jsonHeader (header) {
  return {
    ...header,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Origin': getOrigin()
  };
}

function genGetParams (data) {
  let url = '';
  Object.keys(data).forEach((key) => {
    url += `${url === '' ? '' : '&'}${key}=${data[key]}`;
  });

  return url;
}

async function parseAPIResponse (body, jsonNeeded = true) {
  if (body.ok) {
    let json = {};
    switch (body.status) {
      case 200:
        json = jsonNeeded ? await body.json() : {};
        return {
          ok: true,
          json: json
        };
      case 201:
        json = jsonNeeded ? await body.json() : {};
        return {
          ok: true,
          json: json
        };
      case 204: // No content
        return {
          ok: true,
          json: {}
        };
      default:
        return genError(body.status, body.statusText);
    }
  } else {
    return genError(body.status, body.statusText);
  }
}

function genError (status, message) {
  return {
    ok: false,
    error: {
      type: status,
      message: message
    }
  };
}

async function put (endpoint, data = false) {
  let response = false;
  let url = `${ubaUrlRoot}/${endpoint}`;
  let headerParam = authHeader();
  let params = {
    method: 'put',
    headers: jsonHeader(headerParam)
  };

  if (data) {
    params['body'] = JSON.stringify(data);
  }

  try {
    const responseBody = await fetchAndTrackSession(url, params);
    response = await parseAPIResponse(responseBody);
  } catch (error) {
    errorSvc.onError(error);
    response = {
      ok: false,
      error: {
        type: 'exception',
        message: error.message
      }
    };
  }

  return response;
}

async function del (endpoint, jsonNeeded = false) {
  let response = false;
  let url = `${ubaUrlRoot}/${endpoint}`;
  let headerParam = authHeader();
  try {
    const responseBody = await fetchAndTrackSession(url, {
      method: 'delete',
      headers: headerParam
    });

    response = await parseAPIResponse(responseBody, jsonNeeded);
  } catch (error) {
    errorSvc.onError(error);
    response = {
      ok: false,
      error: {
        type: 'exception',
        message: error.message
      }
    };
  }
  return response;
}

async function api (endpoint, data) {
  let response = false;
  let url = `${ubaUrlRoot}/${endpoint}`;
  let headerParam = authHeader();
  try {
    if (data) url += `?${genGetParams(data)}`;
    const responseBody = await fetchAndTrackSession(url, {
      method: 'get',
      headers: headerParam
    });
    response = await parseAPIResponse(responseBody);
  } catch (error) {
    errorSvc.onError(error);
    response = {
      ok: false,
      error: {
        type: 'exception',
        message: error.message
      }
    };
  }

  return response;
}

async function get (endpoint, data) {
  return await api(endpoint, data);
}

async function post (endpoint, data = false, jsonNeeded = true) {
  let response = false;
  let url = `${ubaUrlRoot}/${endpoint}`;
  let headerParam = authHeader();
  let params = {
    method: 'post',
    headers: jsonHeader(headerParam)
  };

  if (data) {
    params['body'] = JSON.stringify(data);
  }

  try {
    const responseBody = await fetchAndTrackSession(url, params);
    response = await parseAPIResponse(responseBody, jsonNeeded);
  } catch (error) {
    errorSvc.onError(error);
    response = {
      ok: false,
      error: {
        type: 'exception',
        message: error.message
      }
    };
  }

  return response;
}

async function patchAPI (endpoint, data) {
  let response = false;
  let url = `${ubaUrlRoot}/${endpoint}`;
  let headerParam = await authHeader();
  try {
    if (data) url += `?${genGetParams(data)}`;
    const responseBody = await fetchAndTrackSession(url, {
      method: 'PATCH',
      headers: headerParam
    });
    response = await parseAPIResponse(responseBody);
  } catch (error) {
    errorSvc.onError(error);
    response = {
      ok: false,
      error: {
        type: 'exception',
        message: error.message
      }
    };
  }
  return response;
}

async function patch (endpoint, data) {
  return await patchAPI(endpoint, data);
}

export default {
  api,
  get,
  put,
  post,
  del,
  patch
};



/** WEBPACK FOOTER **
 ** ./src/services/ubaRequest.js
 **/